'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
}

export function Switch({
  checked,
  onCheckedChange,
  disabled = false,
  id,
  ...rest
}: SwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={rest['aria-label']}
      disabled={disabled}
      onClick={() => !disabled && onCheckedChange(!checked)}
      className={cn(
        // min-h-0/min-w-0 override the global `button { min-height:44px;
        // min-width:44px }` base rule — without them the 24×44 track is
        // inflated to a ~44×44 near-square, so rounded-full reads as a round
        // knob in a round box instead of a knob sliding inside a pill track.
        'relative inline-flex h-6 w-11 min-h-0 min-w-0 shrink-0 items-center rounded-full transition-colors duration-200 ease focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2',
        checked ? 'bg-accent' : 'bg-surface-3',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <span
        aria-hidden
        className={cn(
          // border-border-strong gives the white knob a visible edge on the
          // light Daylight off-track (bg-surface-3); on Booth the dark track
          // already provides the contrast.
          'inline-block h-5 w-5 transform rounded-full border border-border-strong bg-white shadow-sm transition-transform duration-200 ease',
          checked ? 'translate-x-[22px]' : 'translate-x-0.5'
        )}
      />
    </button>
  );
}
